import Flickity from 'flickity';

const initFlexCarousels = (elements) => {
    elements.forEach((element) => {
        const panels = [...element.querySelectorAll('.js-flex-panel')];
        const dots = [...element.querySelectorAll('.js-carousel-dot')];
        const prev = element.querySelector('.js-carousel-prev');
        const next = element.querySelector('.js-carousel-next');

        let current = 0;
        const sliders = {};

        // Initialise a Flickity slider inside the given panel (only once)
        const initSlider = (index) => {
            const sliderEl = panels[index].querySelector('.js-flex-slider');

            if (!sliderEl || sliders[index]) {
                return;
            }

            sliders[index] = new Flickity(sliderEl, {
                cellAlign: 'left',
                contain: true,
                prevNextButtons: true,
                pageDots: false,
                draggable: true
            });
        };

        // Move to a panel by index, wrapping around at each end
        const goTo = (index) => {
            current = (index + panels.length) % panels.length;

            panels.forEach((panel, i) => {
                panel.classList.toggle('active', i === current);
            });

            dots.forEach((dot, i) => {
                dot.classList.toggle('active', i === current);
            });

            initSlider(current);

            if (sliders[current]) {
                sliders[current].resize();
            }
        };

        // Dot clicks jump directly to the corresponding panel
        dots.forEach((dot) => {
            dot.addEventListener('click', () => {
                goTo(parseInt(dot.dataset.count, 10));
            });
        });

        if (prev) {
            prev.addEventListener('click', () => goTo(current - 1));
        }

        if (next) {
            next.addEventListener('click', () => goTo(current + 1));
        }

        panels.forEach((panel, index) => initSlider(index));
    });
};

export { initFlexCarousels as default };
